import { toRaw } from 'vue';
import { userOnboardingInterface } from '@/api/users';
import { useCurrentUserStore } from '@/stores/currentUser';
import { useNarrative } from './useNarrative';

export enum availableToursEnum {
    AccountSettingsConfigured = 'accountSettingsConfigured',
    WarehouseConfigured = 'warehouseConfigured',
    ServicesConfigured = 'servicesConfigured',
    ClientUser = 'clientUser',
    ShipmentIndex = 'shipmentIndex',
    InboundShipment = 'inboundShipment',
    OutboundShipment = 'outboundShipment',
    Inventory = 'inventory',
    Billing = 'billing',
}

export default function useUserOnboarding(): { isComplete: (type: availableToursEnum) => boolean; isDismissed: (type: availableToursEnum) => boolean; isBannerVisible: (type: availableToursEnum) => boolean; markComplete: (type: availableToursEnum) => Promise<void>; dismiss: (type: availableToursEnum) => Promise<void>; resetGuide: (type: availableToursEnum) => Promise<void>; } {
    const { currentUser } = useNarrative();
    const currentUserStore = useCurrentUserStore();

    const isComplete = (type: availableToursEnum): boolean =>
        currentUser.value.onboarding?.[type] === 'complete';

    const isDismissed = (type: availableToursEnum): boolean =>
        currentUser.value.onboarding?.[type] === 'cancelled';

    const isBannerVisible = (type: availableToursEnum): boolean => {
        const value = currentUser.value.onboarding?.[type];
        return value !== 'complete' && value !== 'cancelled';
    };

    const markComplete = (type: availableToursEnum): Promise<void> => {
        if (isComplete(type)) return Promise.resolve();
        const onboarding: userOnboardingInterface = structuredClone(toRaw(currentUser.value.onboarding) ?? {});
        onboarding[type] = 'complete';
        return currentUserStore.updateUserOnboarding(onboarding);
    };

    const dismiss = (type: availableToursEnum): Promise<void> => {
        if (isDismissed(type)) return Promise.resolve();
        const onboarding: userOnboardingInterface = structuredClone(toRaw(currentUser.value.onboarding) ?? {});
        onboarding[type] = 'cancelled';
        return currentUserStore.updateUserOnboarding(onboarding);
    };

    const resetGuide = (type: availableToursEnum): Promise<void> => {
        const onboarding: userOnboardingInterface = structuredClone(toRaw(currentUser.value.onboarding) ?? {});
        onboarding[type] = 1;
        return currentUserStore.updateUserOnboarding(onboarding);
    };

    return {
        isComplete,
        isDismissed,
        isBannerVisible,
        markComplete,
        dismiss,
        resetGuide,
    };
}
